<script>
import ConsultantContactCard from '@components/help/consultant-contact-card.vue'
import { mapActions } from 'vuex'

export default {
  name: 'HelpExpansionPanelContent',

  components: { ConsultantContactCard },

  props: {
    clientId: { type: Number, required: true },
    clientName: { type: String, required: true },
  },

  data() {
    return {
      isLoaded: false,
      contact: null,
    }
  },

  computed: {
    defaultHelpContact() {
      return {
        name: this.$t('help.defaultContact.name'),
        phoneNumber: this.$t('help.defaultContact.number'),
      }
    },
  },

  created() {
    this.loadContact()
  },

  methods: {
    ...mapActions({
      loadClientAdditionalInformation: 'client/loadClientAdditionalInformation',
    }),

    async loadContact() {
      const {
        data: clientData,
        error,
      } = await this.loadClientAdditionalInformation(this.clientId)

      if (error) {
        this.contact = this.defaultHelpContact
        this.isLoaded = true
        return
      }

      this.contact =
        clientData?.ownerName && clientData?.ownerPhone
          ? {
              name: clientData.ownerName,
              phoneNumber: clientData.ownerPhone,
              clientName: this.clientName,
            }
          : this.defaultHelpContact

      this.isLoaded = true
    },
  },
}
</script>

<template>
  <div>
    <div v-if="!isLoaded" class="text-center py-4">
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>

    <ConsultantContactCard
      v-else-if="contact"
      class="mt-4"
      :contact="contact"
    />

    <div v-else class="text-center py-4 text--secondary">
      {{ $t('help.noContactInformationAvailable') }}
    </div>
  </div>
</template>
